import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'
import { Error } from 'components'

const AppRouter = () => {
  return (
    <Switch>
      <Route exact path='/'>
        <PageLayout>
          <Error type='404' />
        </PageLayout>
      </Route>
      <Route
        path='/crypto-pay'
        render={(routeProps) => require('./CryptoPay').default(routeProps)}
      />
      <Route
        path='/error'
        render={(routeProps) => (
          <PageLayout>{require('./Error').default(routeProps)}</PageLayout>
        )}
      />
      <Route
        path='/iframe'
        render={(routeProps) => require('./Iframe').default(routeProps)}
      />
      <Route
        path='/pay-page'
        render={(routeProps) => require('./PayPage').default(routeProps)}
      />
      <Route
        path='/npss'
        render={(routeProps) => require('./NPSS').default(routeProps)}
      />
      <Route path='*'>
        <PageLayout>
          <Error type='404' />
        </PageLayout>
      </Route>
    </Switch>
  )
}

export default AppRouter
